import { useQuery } from '@tanstack/react-query';

import { useSegment } from '@telialt/utils/src/segment';

import { apiGetRetailsMapSearch } from '../api';
import { RETAILS_MAP_QUERY_KEY } from '../constants';

export const useRetailsMapSearch = (productCode?: string) => {
    const segment = useSegment();

    return useQuery({
        queryKey: [RETAILS_MAP_QUERY_KEY.SEARCH, productCode],
        queryFn: () => apiGetRetailsMapSearch(segment, productCode),
        select: ({ data }) => data,
    });
};
